var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Collapse", {
    staticClass: "green-operation__assessment green-operation__green-fit-out",
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [
            _c(
              "HKLLeftRight",
              [
                _c("span", { staticClass: "font-bold" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "tenancy.greenOperation.assessments.greenFitOut.title"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                !_vm.isEdit && _vm.canViewPoint
                  ? _c("HKLInputPoints", {
                      attrs: { isEdit: false },
                      model: {
                        value: _vm.points,
                        callback: function ($$v) {
                          _vm.points = $$v
                        },
                        expression: "points",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              [
                _c(
                  "HKLLeftRight",
                  { staticClass: "green-operation__assessment-title" },
                  [
                    _c("div", [
                      _c("span", { staticClass: "font-bold" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "tenancy.greenOperation.assessments.greenFitOut.submission"
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.enableTenantProjectsFeature
                        ? _c(
                            "span",
                            {
                              staticClass: "underline pointer",
                              on: {
                                click: function () {
                                  return _vm.navToAllProjects()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "tenancy.greenOperation.assessments.greenFitOut.viewMore"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.canViewPoint
                      ? _c("HKLInputPoints", {
                          attrs: { isEdit: _vm.isEdit },
                          model: {
                            value: _vm.submission.point,
                            callback: function ($$v) {
                              _vm.$set(_vm.submission, "point", $$v)
                            },
                            expression: "submission.point",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isTenant && _vm.tableAttrs.dataSource.length === 0
                  ? [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("emptyValue")) + "\n      "
                      ),
                    ]
                  : _vm.tableAttrs.dataSource.length > 0
                  ? _c(
                      "HKLTable",
                      _vm._b({}, "HKLTable", _vm.tableAttrs, false)
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }